import { render } from "./GPUTab.vue?vue&type=template&id=3c54cf98&scoped=true"
import script from "./GPUTab.vue?vue&type=script&lang=js"
export * from "./GPUTab.vue?vue&type=script&lang=js"

import "./GPUTab.vue?vue&type=style&index=0&id=3c54cf98&scoped=true&lang=css"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c54cf98"]])

export default __exports__